import { gql } from "@/gql";

export const GET_SALON_TOTAL_CAPACITIES = gql(`
  query GetSalonTotalCapacities($salonId: String!, $filters: SalonTotalCapacityFilterInput) {
    getSalonTotalCapacities(salonId: $salonId, filters: $filters) {
      capacities {
        id
        franchiseId
        salonId
        startTime
        endTime
        dayOfWeeks
        maxTotal
        name
        isActive
        priority
        color
        createdAt
        updatedAt
      }
    }
  }
`);

export const GET_SALON_TOTAL_CAPACITY = gql(`
  query GetSalonTotalCapacity($salonId: String!, $capacityId: ID!) {
    getSalonTotalCapacity(salonId: $salonId, capacityId: $capacityId) {
      id
      franchiseId
      salonId
      startTime
      endTime
      dayOfWeeks
      maxTotal
      name
      isActive
      priority
      color
      createdAt
      updatedAt
    }
  }
`);

export const CREATE_SALON_TOTAL_CAPACITY = gql(`
  mutation CreateSalonTotalCapacity($salonId: String!, $input: CreateSalonTotalCapacityInput!) {
    createSalonTotalCapacity(salonId: $salonId, input: $input) {
      id
      franchiseId
      salonId
      startTime
      endTime
      dayOfWeeks
      maxTotal
      name
      isActive
      priority
      color
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_SALON_TOTAL_CAPACITY = gql(`
  mutation UpdateSalonTotalCapacity($salonId: String!, $capacityId: ID!, $input: UpdateSalonTotalCapacityInput!) {
    updateSalonTotalCapacity(salonId: $salonId, capacityId: $capacityId, input: $input) {
      id
      franchiseId
      salonId
      startTime
      endTime
      dayOfWeeks
      maxTotal
      name
      isActive
      priority
      color
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_SALON_TOTAL_CAPACITY = gql(`
  mutation DeleteSalonTotalCapacity($salonId: String!, $capacityId: ID!) {
    deleteSalonTotalCapacity(salonId: $salonId, capacityId: $capacityId)
  }
`);
